import styled from 'styled-components';

export const Section = styled.section`
    boxFlex: 1;
    color: #ffffff;
    flex: 1;
    height: 64px;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const H1 = styled.h1`
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 64px;
    margin: 0;
    padding-top: 0;
    text-overflow: ellipsis;
`;